import { UserChallengeGoal } from '../services/models/challenges.request';

export class GetAdminChallenges {
  static readonly type = '[Challenges] - Get admin challenges';
}

export class GetUserChallenges {
  static readonly type = '[Challenges] - Get user challenges';
}

export class PostUserDailyChallenge {
  static readonly type = '[Challenges] - Post user daily challenge';
  constructor(public readonly target: UserChallengeGoal) {}
}

export class PostUserMonthlyChallenge {
  static readonly type = '[Challenges] - Post user monthly challenge';
  constructor(public readonly target: UserChallengeGoal) {}
}

export class PutUserDailyChallenge {
  static readonly type = '[Challenges] - Put user daily challenge';
  constructor(public readonly target: UserChallengeGoal) {}
}

export class PutUserMonthlyChallenge {
  static readonly type = '[Challenges] - Put user monthly challenge';
  constructor(public readonly target: UserChallengeGoal) {}
}

export class DeleteUserDailyChallenge {
  static readonly type = '[Challenges] - Delete user daily challenge';
}

export class DeleteUserMonthlyChallenge {
  static readonly type = '[Challenges] - Delete user monthly challenge';
}

export class GetChallengesHistory {
  static readonly type = '[Challenges] - Get challenges history';
  constructor(public readonly pageSize: number, public readonly page: number) {}
}

export class SetInitialValue {
  static readonly type = '[Challenges] - Set initial value';
  constructor(public readonly initialValue: number) {}
}